// extracted by mini-css-extract-plugin
module.exports = {"container":"quote_container__ZeBmu","quote":"quote_quote__Xc3o8","name":"quote_name__VQTPh","position":"quote_position__bFkHW"};